import TourPage from "@/components/TourPage";

export default function NakuruMaasaiMara5Day() {
  return (
    <TourPage
      tourId="kenya/nakuru-maasai-mara-5-day"
      title="5 Days Lake Nakuru and Masai Mara Safari"
      duration="5 Days / 4 Nights"
      price="Contact for price"
      image="/lakenakuruflamingos.jpg"
      description="Experience the best of Kenya's wildlife with this 5-day safari combining Lake Nakuru National Park and the Masai Mara National Reserve. Witness flamingos, rhinos, big cats, and the great wildebeest migration (seasonal)."
      itinerary={[
        {
          day: 1,
          title: "Nairobi to Lake Nakuru",
          description: "Journey to the flamingo-dotted Lake Nakuru.",
          activities: [
            "Morning pickup from your Nairobi hotel",
            "Drive to Lake Nakuru National Park",
            "Afternoon game drive around the lake",
            "Bird watching and wildlife viewing"
          ],
          accommodation: "Lake Nakuru Lodge or Similar",
          meals: "Lunch, Dinner"
        },
        {
          day: 2,
          title: "Lake Nakuru to Masai Mara",
          description: "Travel to the iconic Masai Mara.",
          activities: [
            "Morning game drive in Lake Nakuru",
            "Drive to Masai Mara National Reserve",
            "Evening game drive in the reserve"
          ],
          accommodation: "Mara Lodge or Similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Full Day Masai Mara",
          description: "Explore the rich wildlife of Masai Mara.",
          activities: [
            "Full day of game drives",
            "Search for the Big Five",
            "Visit to the Mara River (optional)",
            "Evening game viewing"
          ],
          accommodation: "Mara Lodge or Similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 4,
          title: "Masai Mara Exploration",
          description: "Another day in the wildlife paradise.",
          activities: [
            "Early morning game drive",
            "Visit to a Masai village",
            "Afternoon game drive",
            "Optional hot air balloon safari (extra cost)"
          ],
          accommodation: "Mara Lodge or Similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 5,
          title: "Masai Mara to Nairobi",
          description: "Final game drive and return to Nairobi.",
          activities: [
            "Morning game drive",
            "Breakfast at the lodge",
            "Drive back to Nairobi",
            "Drop-off at your hotel or airport"
          ],
          meals: "Breakfast, Lunch"
        }
      ]}
      inclusions={[
        "All transportation in a 4x4 safari vehicle",
        "Professional safari guide",
        "All park entrance fees",
        "Full board accommodation",
        "Game drives as specified",
        "Bottled water during safari",
        "Masai village visit"
      ]}
      exclusions={[
        "International flights",
        "Visa fees",
        "Travel insurance",
        "Personal items",
        "Tips and gratuities",
        "Optional activities",
        "Drinks and beverages"
      ]}
    />
  );
}
